// Types
import type { EAutomationMode } from '~/modules/opportunities/automated-email/types';

enum EAutomatedEmailFilterGroupId {
  PROPERTY = 'property',
  DATA = 'data',
  CONSENT = 'consent',
}

type TAutomatedEmailFilterGroup = {
  id: EAutomatedEmailFilterGroupId;
  label: string;
  badges: string[];
};

type TAutomationModeOption = {
  id: string;
  value: EAutomationMode;
  title: string;
  description: string;
  disabled?: boolean;
};

type TSemiAutomaticAutoSendOption = {
  label: string;
  days: number;
  disabled?: boolean;
};

/** API / UI trigger slugs supported in automated-email settings. */
type TKnownUserTriggerName = 'market-success' | 'reduced' | 'withdrawn';

/** UI “days” selector for semi-automatic send delay (0 = not set / N/A for mapping). */
type TSemiAutomaticUiDays = 0 | 1 | 2 | 3;

/** Supported API `send_delay_hours` values when mapping to UI days. */
type TApiSendDelayHours = 24 | 48 | 72;

type TTriggerDisplayMeta = {
  name: string;
  description: string;
};

type TAutomatedEmailUserTriggerSyncRowTyped = {
  trigger_name: TKnownUserTriggerName;
  is_active: boolean;
};

type TUserTemplateUpdatePayload = {
  subject: string;
  content: string;
};

export { EAutomatedEmailFilterGroupId };
export type {
  EAutomationMode,
  TAutomatedEmailFilterGroup,
  TAutomationModeOption,
  TSemiAutomaticAutoSendOption,
  TKnownUserTriggerName,
  TSemiAutomaticUiDays,
  TApiSendDelayHours,
  TTriggerDisplayMeta,
  TAutomatedEmailUserTriggerSyncRowTyped,
  TUserTemplateUpdatePayload,
};
